import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import MissionVision from '../components/MissionVision';
import Services from '../components/Services';
import Events from '../components/Events';
import News from '../components/News';
import NewsPopup from '../components/NewsPopup';
import About from '../components/About';
import Partners from '../components/Partners';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import { useTranslation } from 'react-i18next';

function LandingPage() {
  const { t } = useTranslation();

  return (
    <div className="App">
      {/* Metadados de acessibilidade */}
      <div className="sr-only" role="region" aria-label="Informações de acessibilidade">
        <p>{t('accessibility.info')}</p>
        <p>{t('accessibility.tabInfo')}</p>
        <p>{t('accessibility.enterInfo')}</p>
      </div>

      <Header />
      <main id="main-content" role="main" aria-label="Conteúdo principal">
        <Hero />
        <MissionVision />
        <Services />
        <Events />
        <News />
        <About />
        <Partners />
        <Contact />
      </main>
      <Footer />

      {/* Featured news popup (1x per browser session) */}
      <NewsPopup />
    </div>
  );
}

export default LandingPage;
